import { ApolloProvider } from '@apollo/client';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { App } from './app/App';
import { router } from './app/router/router';
import { apolloClient } from './shared/api/apolloClient';
import './shared/i18n/i18n';
// Self-hosted brand typefaces (bundled — work fully offline for on-prem clinic deploys):
// Inter Variable for UI/body, Baloo 2 Variable for the rounded display / brand voice.
import '@fontsource-variable/inter';
import '@fontsource-variable/baloo-2';
import './shared/styles/globals.css';
import { applyTheme, useThemeStore } from './stores/themeStore';

applyTheme(useThemeStore.getState().mode);
useThemeStore.subscribe((state) => applyTheme(state.mode));

const root_el = document.getElementById('root');
if (!root_el) throw new Error('#root not found');

createRoot(root_el).render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <App>
        <RouterProvider router={router} />
      </App>
    </ApolloProvider>
  </React.StrictMode>,
);
